import { createFileRoute } from '@tanstack/react-router';
import { ZakatCalculatorPage } from '~/components/pages/ZakatCalculatorPage';
import { pageHeadMeta } from '~/lib/seo';
import zakatStylesHref from '~/styles/zakat.css?url';

export const Route = createFileRoute('/zakat-calculator')({
  head: () =>
    pageHeadMeta({
      title: 'Calculate Your Zakat Today | Cash, Gold & Investments',
      description:
        "Calculate your Zakat with nsave's online calculator. Include cash, bank balances, gold, silver, and investments to see how much to pay today.",
      path: '/zakat-calculator',
      stylesheets: [zakatStylesHref],
    }),
  component: ZakatCalculatorPage,
});
